/* Linorly : cadeaux offerts ajoutés / retirés automatiquement du panier selon l'offre achetée.
   Offre -> cadeaux (IDs de variantes). Un cadeau = 1 ligne à £0, quantité 1. */
(function () {
  var MAP = {
    67658788110499: [67658882482339],                 // SteamPress Steamer + Case -> Fabric Care Guide
    67657233629347: [67658882482339, 67658882515107], // SteamPress Complete Kit -> Fabric Care Guide + 2-Year Warranty
    67657233072291: [67658883137699],                 // HomeSense 2-Pack -> Home Safety Blueprint
    67657233105059: [67658883137699]                  // HomeSense 3-Pack -> Home Safety Blueprint
  };
  var GIFTS = [67658882482339, 67658882515107, 67658883137699];
  var busy = false, again = false, timer = null, selfEvent = false;

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function sync() {
    if (busy) { again = true; return; }
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var want = {};
      cart.items.forEach(function (it) { (MAP[it.variant_id] || []).forEach(function (g) { want[g] = true; }); });
      var have = {}, fixes = [];
      cart.items.forEach(function (it) {
        if (GIFTS.indexOf(it.variant_id) === -1) return;
        if (!want[it.variant_id] || have[it.variant_id]) fixes.push({ id: it.key, quantity: 0 });
        else { have[it.variant_id] = true; if (it.quantity !== 1) fixes.push({ id: it.key, quantity: 1 }); }
      });
      var add = Object.keys(want).filter(function (g) { return !have[g]; }).map(function (g) { return { id: Number(g), quantity: 1 }; });
      var chain = Promise.resolve(), changed = false;
      fixes.forEach(function (f) { chain = chain.then(function () { changed = true; return post('/cart/change.js', f); }); });
      if (add.length) chain = chain.then(function () { changed = true; return post('/cart/add.js', { items: add }); });
      return chain.then(function () { return changed; });
    }).then(function (changed) {
      busy = false;
      if (changed) return refresh();
      if (again) { again = false; sync(); }
    }).catch(function () { busy = false; });
  }
  /* Re-dessine le panier (page panier + tiroir) sans recharger : même événement que le thème, avec les sections HTML */
  function refresh() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) { var id = el.dataset.sectionId || el.getAttribute('data-section-id'); if (id && ids.indexOf(id) === -1) ids.push(id); });
    var cartP = fetch('/cart.js').then(function (r) { return r.json(); });
    var secP = ids.length ? fetch(location.pathname + '?sections=' + ids.join(',')).then(function (r) { return r.json(); }) : Promise.resolve(null);
    return Promise.all([cartP, secP]).then(function (res) {
      var cart = res[0], sections = res[1];
      if (!sections && /^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
      selfEvent = true;
      var ev = new Event('shopify:cart:lines-update', { bubbles: true });
      ev.promise = Promise.resolve({ detail: { cart: cart, sections: sections || {} } });
      document.dispatchEvent(ev);
      selfEvent = false;
      $$bubble(cart.item_count);
    });
  }
  function $$bubble(n) {
    document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach(function (el) { el.textContent = n; });
  }
  function later() { clearTimeout(timer); timer = setTimeout(sync, 300); }
  /* Horizon : événement standard Shopify après chaque ajout / modification du panier */
  document.addEventListener('shopify:cart:lines-update', function (e) {
    if (selfEvent) return;
    var p = (e && (e.promise || (e.detail && e.detail.promise)));
    if (p && typeof p.then === 'function') p.then(later, later); else setTimeout(later, 1200);
  }, true);
  document.addEventListener('cart:update', function (e) {
    var d = e.detail || {};
    if (d.sourceId === 'gs-gifts' || (d.data && d.data.source === 'gs-gifts')) return;
    later();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
